import gql from 'graphql-tag';

export const GET_BLOG_ARTICLES = gql`
  query getBlogArticles($status: ArticleBlogStatusEnum,$pagination: PaginationInput) {
    blogArticles(status: $status, pagination: $pagination) {
      totalCount
      edges {
        cursor
        node {
          id
          title
          text
          publicationDate
          image
          url
          theme {
            id
            name
            slug
          }
          
        }
      }
    }
  }
`;

export const GET_BLOG_ARTICLES_BY_ID = gql`
  query getBlogArticleById($id: ID!) {
    blogArticleById(id: $id) {
      id
      title
      text
      publicationDate
      image
      url
      theme {
          id
          name
          slug
        }
    }
  }
`;
